export const SET_VALET_SETTINGS = 'SET_VALET_SETTINGS'
export const SET_TICKET_DATA = 'SET_TICKET_DATA'
export const SET_SERVICE_FEE = 'SET_SERVICE_FEE'
export const SET_BUILDING_DATA = 'SET_BUILDING_DATA'

export const initialState = {
  ticketData: {},
  valetSettings: {},
  buildingData: {},
  serviceFee: 0,
}

const parkingReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TICKET_DATA:
      return { ...state, ticketData: action.payload }
    case SET_VALET_SETTINGS:
      return { ...state, valetSettings: action.payload }
    case SET_SERVICE_FEE:
      return { ...state, serviceFee: action.payload }
    case SET_BUILDING_DATA:
      return { ...state, buildingData: action.payload }
    default:
      return state
  }
}

export default parkingReducer

export const setValetSettings = (payload) => {
  return {
    type: SET_VALET_SETTINGS,
    payload,
  }
}

export const setTicketData = (payload) => {
  return {
    type: SET_TICKET_DATA,
    payload,
  }
}

export const setServiceFee = (payload) => {
  return {
    type: SET_SERVICE_FEE,
    payload,
  }
}

export const setBuildingData = (payload) => {
  return {
    type: SET_BUILDING_DATA,
    payload,
  }
}
